export const TRANSACTION_STATUS = {
    notPaid: '0',
    received: '1',
    finished: '2',
    cancelledByCustomer: '3',
    cancelledByCashier: '4',
    pending: '5',
    merged: '8',
}